import { jsxs, jsx } from "react/jsx-runtime";
const IconSocialFacebookSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15.016 2c.8 0 2.183.157 2.748.314v3.502a16.218 16.218 0 0 0-1.46-.047c-2.074 0-2.875.786-2.875 2.827v1.367h3.85l-.71 3.863h-3.14V22H8.843v-8.174H6.236V9.963h2.607V8.298C8.843 3.995 10.791 2 15.015 2" })
    ]
  }
);
export {
  IconSocialFacebookSvg
};
